export const DeclarationMenuName = 'declarationMenuComponent';
